import { DashboardOnboardingStatus } from "../types";

const ONBOARDING_STEP_KEYS: readonly (keyof DashboardOnboardingStatus)[] = [
  "has_toggled_scopes",
  "has_successfully_linked_account",
  "has_pulled_common_model_data",
  "has_made_request",
  "has_opened_production_link",
] as const;

export const TOTAL_ONBOARDING_STEPS = ONBOARDING_STEP_KEYS.length;

export const hasOrgOnboardedSuccessfully = (
  dashboardOnboardingStatus?: DashboardOnboardingStatus,
) => {
  return (
    dashboardOnboardingStatus?.has_made_request &&
    dashboardOnboardingStatus?.has_successfully_linked_account &&
    dashboardOnboardingStatus?.has_pulled_common_model_data &&
    dashboardOnboardingStatus?.has_opened_production_link &&
    dashboardOnboardingStatus?.has_toggled_scopes
  );
};

export function getOnboardingStepCount(status: DashboardOnboardingStatus | null): number {
  return ONBOARDING_STEP_KEYS.filter((key) => status?.[key]).length;
}
